<template>
  <div class="clearfix record_number">
    <div class="record_title">©&nbsp;{{ title }}</div>
    <!--      {{ aTitle }}-->
    <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">{{ recordnumber }}</a>

    <!--      <div v-if="!isEmptyStr(recordnumber)">-->
    <!--        -->
    <!--      </div>-->
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {
    // 可跳转的公网备案号
    aTitle: {
      type: String,
      default: '备案号'
    },
    // 正常公司版权
    title: {
      type: String,
      default: ''
    },
    // 备案号
    recordnumber: {
      type: String,
      default: ''
    }
  },
  methods: {
    isEmptyStr(str) {
      return str == null || str == undefined || str == ''
    }
  }
}
</script>
<style scoped>
.ui_mar_top_24 {
  margin-top: 24px
}

.ui_mar_top_12 {
  margin-top: 12px
}

.record_number {
  position: fixed;
  bottom: 12px;
  text-align: center;
  width: 100%;
  font-size: 12px;
  color: #999999;
}

.record_title {
  display: inline-block;
  height: 32px;
  line-height: 32px;
  background: url('./icon_safe.png') no-repeat left center;
  background-size: 20px 20px;
  padding-left: 24px;
  padding-right: 12px;
}

.record_number a {
  height: 32px;
  line-height: 32px;
}

.record_number a:visited {
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/components/RecordNumber/RecordNumber.vue